import React, { useContext, useMemo } from "react";

import isEmpty from "lodash.isempty";
import { observer } from "mobx-react";

import ComponentContext from "../../contexts/ComponentContext";
import { useStores } from "../../contexts/StoreContext";
import Hero from "../../shared/components/Hero/Hero";

function SingleVenueHero() {
  const { venuePageStore } = useStores();
  const { contentClassName, content, textColor } = useContext(ComponentContext);

  const { venueName } = venuePageStore;
  const { bannerUrl } = venuePageStore.page.venue.profile;

  const venueNameKeyword = "<venueName>";
  const heroText = isEmpty(content)
    ? `## Join ${venueName}`
    : content.replace(venueNameKeyword, venueName);

  const heroProps = useMemo(
    () => ({
      color: textColor ?? "#000",
      contentClassName,
      heroImage: {
        data: {
          attributes: { url: bannerUrl },
        },
      },
      minHeight: bannerUrl ? "45vh" : "15vh",
      text: heroText,
    }),
    [venueName]
  );

  return (
    <ComponentContext.Provider value={heroProps}>
      <Hero />
    </ComponentContext.Provider>
  );
}

export default observer(SingleVenueHero);
